import React, { Component} from 'react'
import { Link } from 'react-router-dom'

class NotFound extends Component
{
  render() {
    return(
      <React.Fragment>
        <div className="not-found">
          <div className="content">
            <h1>404</h1>
            <p className="lead">
              잘못된 요청입니다.
            </p>
            <Link to="/" className="btn-go-back">
              &lt; 뒤로
            </Link>
          </div>
        </div>
  		</React.Fragment>
    )
  }
}

export default NotFound
